import { getViewerTimezoneLabel } from "../../helpers/utils";

export const FIELD_APP_TIMEZONE_MODES = {
  VIEWER: "viewer",
  DATA: "data",
};

/** Fuso padrão onde o GPS do app de campo é registrado (Brasil). */
export const FIELD_APP_DATA_TIMEZONE = "America/Sao_Paulo";

const STORAGE_PREFIX = "field-app-tracking-tz-mode-";

export function readTrackingTimezoneMode(farmId) {
  try {
    const raw = localStorage.getItem(`${STORAGE_PREFIX}${farmId || "default"}`);
    if (
      raw === FIELD_APP_TIMEZONE_MODES.VIEWER ||
      raw === FIELD_APP_TIMEZONE_MODES.DATA
    ) {
      return raw;
    }
  } catch (error) {
    /* ignore */
  }
  return FIELD_APP_TIMEZONE_MODES.VIEWER;
}

export function writeTrackingTimezoneMode(farmId, mode) {
  try {
    localStorage.setItem(`${STORAGE_PREFIX}${farmId || "default"}`, mode);
  } catch (error) {
    /* ignore */
  }
}

export function getTimezoneModeShortLabel(mode) {
  if (mode === FIELD_APP_TIMEZONE_MODES.DATA) {
    return FIELD_APP_DATA_TIMEZONE;
  }
  return getViewerTimezoneLabel();
}

function toDate(value) {
  if (value == null) return null;
  const date = value instanceof Date ? value : new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
}

function resolveTimeZone(mode) {
  return mode === FIELD_APP_TIMEZONE_MODES.DATA
    ? FIELD_APP_DATA_TIMEZONE
    : undefined;
}

function formatWithIntl(date, mode, options) {
  const timeZone = resolveTimeZone(mode);
  return new Intl.DateTimeFormat("pt-BR", { timeZone, ...options }).format(
    date
  );
}

/**
 * Formata instantes para mapa, gráfico e cartões do rastreamento.
 * variant: hm | dmhm | card | full | map | tooltip
 */
export function formatFieldAppDateTime(value, mode, variant = "card") {
  const date = toDate(value);
  if (!date) return "—";

  switch (variant) {
    case "hm":
      return formatWithIntl(date, mode, {
        hour: "2-digit",
        minute: "2-digit",
      });
    case "dmhm":
      return formatWithIntl(date, mode, {
        day: "2-digit",
        month: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
      });
    case "map": {
      const formatted = formatWithIntl(date, mode, {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      });
      return formatted.replace(", ", " - ");
    }
    case "full":
    case "tooltip":
      return formatWithIntl(date, mode, {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
      });
    case "card":
    default:
      return formatWithIntl(date, mode, {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      });
  }
}
